import { koComponent } from '../../../../ko-utils';
import $api from '../../../../api';
import { FeedbackModel } from '../../../../models/Gen/BaseModels';
import DetailsView from './detailsView';
import { setReactives } from '../../../../utils/reactive';
import { getLocalSettingsOrDefaultAutoObservable } from '../../../../utils/localSettings';
import { getSomeName } from '../../utils';

class CollectedFeedbackView {
    constructor(params, initParams) {
        this.page = initParams;

        this.view = getLocalSettingsOrDefaultAutoObservable('feedback_inbox_view', 'table');

        DetailsView();

        this.feedbacks = ko.observableArray();
        this.pageInfo = {
            page: ko.observable(),
            pageSize: ko.observable(),
            pagesCount: ko.observable()
        };

        this.allCount = ko.observable();
        this.allCount.subscribe(val => {
            setReactives('feedback-count', val);
        });

        this.detailSelectedFeedback = ko.observable();

        this.getSomeName = getSomeName;

        /*
        const feedbackToHighlight = getHashOrDefault();
        if (feedbackToHighlight && feedbackToHighlight.startsWith('fbd_')) {
            setTimeout(() => {
                const el = document.getElementById(feedbackToHighlight);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth' });
                    el.classList.add('highlight-bg-blink');
                }
            }, 100);
            window.location.hash = '';
        }
         */
        this.getPage(1);
    }

    setFeedbacksFromPagedList(pagesList) {
        var res = [];
        for (var feedback of pagesList.items) {
            res.push(new FeedbackModel(feedback));
        }
        this.feedbacks(res);
    }

    getPage(page, pageSize) {
        $api.feedbacks.getFeedbacks(
            { projectCode: auth.project.UniqueCode, page, pageSize },
            {},
            (res) => {
                this.pageInfo.page(page);
                this.pageInfo.pageSize(pageSize);
                this.pageInfo.pagesCount(res.pagesCount);

                this.allCount(res.unresolvedCount);

                this.setFeedbacksFromPagedList(res);
            }
        );
    }

    solve(item) {
        $api.feedbacks.solve(
            { projectCode: auth.project.UniqueCode, id: item.id() },
            {},
            (res) => {
                this.getPage(this.pageInfo.page(), this.pageInfo.pageSize());
            }
        );
    }

    unsolve(item) {
        $api.feedbacks.unsolve(
            { projectCode: auth.project.UniqueCode, id: item.id() },
            {},
            (res) => {
                this.getPage(this.pageInfo.page(), this.pageInfo.pageSize());
            }
        );
    }

    remove(item) {
        if (confirm('Are you sure?')) {
            $api.feedbacks.delete(
                { projectCode: auth.project.UniqueCode, id: item.id() },
                {},
                (res) => {
                    this.getPage(this.pageInfo.page(), this.pageInfo.pageSize());
                }
            );
        }
    }

    showDetail(feedback) {
        document.body.classList.add('fullscreen-overlay-shown');
        this.detailSelectedFeedback(feedback);
    }

    closeDetail() {
        document.body.classList.remove('fullscreen-overlay-shown');
        this.detailSelectedFeedback(null);
    }

    //showScreenshotsModal(feedback) {
    //    this.page.showDialog(ScreenshotsDialog(), { rootPageParent: this, screenshots: ko.unwrap(feedback.screenshots) });
    //}

    //showVideosModal(feedback) {
    //    this.page.showDialog(VideosDialog(), { rootPageParent: this, videos: ko.unwrap(feedback.videos) });
    //}

    //showDetailsModal(feedback) {
    //    this.page.showDialog(DetailsDialog(), {
    //        rootPageParent: this, envInfo: ko.unwrap(feedback.environmentInfo), author: ko.unwrap({
    //            username: feedback.authorUsername,
    //            props: feedback.authorProps
    //        })
    //    });
    //}

    exportToExcel() {
        this.page.showToast('Downloading will start shortly...');
        var link = document.createElement("a");
        link.download = 'export.xlsx';
        link.href = '/api/v1/feedbacks/' + auth.project.UniqueCode + '/export?format=xlsx';
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
}

export default koComponent('collected-feedback-view', CollectedFeedbackView);